export const LOMAN_RED = "#FF1212";
export const ERROR_RED = "#DC2626";
export const GRAY_50 = "#F9FAFB";
